export enum PaymentMethod {
  TradingBalance = 'TradingBalance',
  TradingLimit = 'TradingLimit',
  DayTrade = 'DayTrade',
}

export enum BuyOrderType {
  LimitOrder = 'Limit Order',
  AutoBuy = 'AutoBuy',
  'Auto Buy' = 'Auto Buy',
  MarketOrder = 'Market',
}

export enum SellOrderType {
  LimitOrder = 'Limit Order',
  StopLoss = 'StopLoss',
  TakeProfit = 'TakeProfit',
  MarketOrder = 'Market',
  TrailingStop = 'Trailing Stop',
}

export enum SmartOrderType {
  AutoBuy = 'AutoBuy',
  StopLoss = 'StopLoss',
  TakeProfit = 'TakeProfit',
}

export enum SmartOrderCode {
  AutoBuy = 'AB',
  StopLoss = 'SL',
  TakeProfit = 'TP',
  LimitIfTouched = 'LIT_SELL',
}

export enum TransactionType {
  Buy = 'Buy',
  Sell = 'Sell',
}

// Gradual migrate expiryOption from src/global/TradingModal/constant.ts:expiryOption
export enum Expiry {
  GoodForDay = 'Good For Day',
  GoodTillCancelled = 'Good Till Cancelled',
}

export enum OrderAction {
  Buy = 'BUY',
  Sell = 'SELL',
}

export enum OrderStatus {
  Rejected = 'REJECTED',
  Open = 'OPEN',
  Amended = 'AMENDED',
  Withdrawn = 'WITHDRAWN',
  Match = 'MATCH',
  Ready = 'READY',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Active = 'ACTIVE',
  RequestAmend = 'REQUEST AMEND',
  Succeed = 'SUCCEEDED',
}

export type OrderStatusType =
  | OrderStatus.Rejected
  | OrderStatus.Open
  | OrderStatus.Amended
  | OrderStatus.Withdrawn
  | OrderStatus.Match
  | OrderStatus.Ready
  | OrderStatus.Partial
  | OrderStatus.Pending
  | OrderStatus.Active
  | OrderStatus.RequestAmend
  | OrderStatus.Succeed;

export enum SplitOrderMethodEnum {
  UNSPECIFIED = 'SPLIT_ORDER_METHOD_UNSPECIFIED',
  EQUAL = 'SPLIT_ORDER_METHOD_EQUAL',
  RANDOM = 'SPLIT_ORDER_METHOD_RANDOM_RANGE',
}

export enum PlatformOrderTypes {
  UNSPECIFIED = 'PLATFORM_ORDER_TYPE_UNSPECIFIED',
  LIMIT = 'PLATFORM_ORDER_TYPE_LIMIT_DAY',
  FAK = 'PLATFORM_ORDER_TYPE_MARKET_FAK',
  FAST_ORDER = 'PLATFORM_ORDER_TYPE_FAST_ORDER',
}

export enum AmendSellOrderType {
  LimitIfTouched = 'Limit If Touched',
  StopLoss = 'Stop Loss',
  TakeProfit = 'Take Profit',
}
